import GoldenAgeItem from "./golden-age-item/GoldenAgeItem";
import cancelIcon from '../../../../icons/cancel.png';
import goldenAge1Icon from '../../../../icons/goldenagetier1.png';
import tradeWingIcon from '../../../../icons/trade_wing.png';
import s from './golden-age.module.css';
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import GatheringRateModifierId from "../../../../data/gathering-rate-modifiers/GatheringRateModifierId";
import ProductionSpeedModifierId from "../../../../data/production-speed-modifiers/ProductionSpeedModifierId";
import {unselectSelect} from "../../../../state/GatheringRateModifiersSlice";
import {unselectSelectProductionSpeedModifiers} from "../../../../state/ProducationSpeedModifiersSlice";
import Tooltip from "../../../tooltip/Tooltip";

const ALL_GATHERING_RATES = [GatheringRateModifierId.GOLDEN_AGE_1, GatheringRateModifierId.GOLDEN_AGE_2];
const ALL_PRODUCTION = [ProductionSpeedModifierId.GOLDEN_AGE_3];

function GoldenAge() {
    const dispatch = useAppDispatch();
    const gatheringRateModifiers: { [key: string]: boolean } = useAppSelector((rootState) => rootState.gatheringRateModifiers);

    const noneActive = !ALL_GATHERING_RATES.some(id => gatheringRateModifiers[id]);

    function unselectAll() {
        dispatch(unselectSelect({unselect: ALL_GATHERING_RATES, select: []}));
        dispatch(unselectSelectProductionSpeedModifiers({unselect: ALL_PRODUCTION, select: []}));
    }

    function selectAge1() {
        dispatch(unselectSelect({unselect: ALL_GATHERING_RATES, select: [GatheringRateModifierId.GOLDEN_AGE_1]}));
        dispatch(unselectSelectProductionSpeedModifiers({unselect: ALL_PRODUCTION, select: []}));
    }

    function selectAge2() {
        dispatch(unselectSelect({unselect: ALL_GATHERING_RATES, select: [GatheringRateModifierId.GOLDEN_AGE_2]}));
        dispatch(unselectSelectProductionSpeedModifiers({unselect: ALL_PRODUCTION, select: []}));
    }

    return (
        <Tooltip header="Golden Age" text={'Increases gathering rate.'}>
            <div className={s.goldenAge}>
                <GoldenAgeItem icon={cancelIcon} selected={noneActive} onClick={unselectAll}/>
                <GoldenAgeItem icon={goldenAge1Icon} selected={gatheringRateModifiers[GatheringRateModifierId.GOLDEN_AGE_1]} onClick={selectAge1}/>
                <GoldenAgeItem icon={tradeWingIcon} selected={gatheringRateModifiers[GatheringRateModifierId.GOLDEN_AGE_2]} onClick={selectAge2}/>
            </div>
        </Tooltip>
    );
}

export default GoldenAge;
